<template>
  <v-layout wrap justify-center>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#005eff"
      spinner="bar-fade-scale"
    />
    <v-flex px-2 xs12 sm12 md12 lg12 xl12 text-center>
      <v-layout wrap>
        <v-flex xs12 sm12 md12 lg12 xl12 text-center>
          <!-- <v-card>
             <vue-element-loading :active="graphLoading" :is-full-screen="false" />
            <v-card-text class="pa-5">
              <div class="d-sm-flex align-center">
                <div>
                  <h3
                    class="title blue-grey--text text--darken-2 font-weight-regular"
                  >
                    Sales Overview
                  </h3>
                </div>
                <div class="ml-auto">
                  <div class="d-flex align-center">
                    <div class="d-flex align-center px-2">
                      <v-flex md4>
                      <v-select
                            solo
                            label="Year"
                            v-model="year"
                            dense
                            required
                            :items="years()"
                          ></v-select>
                     </v-flex>
                    </div>
                   
                  </div>
                </div>
              </div>
              <div class="mt-9">
               
                <apexchart
                  ref="realtimeChart"
                  v-if="graphSuccess"
                  type="bar"
                  height="400"
                  :options="chartOptions"
                  :series="series"
                ></apexchart>
              </div>
            </v-card-text>
          </v-card> -->
        </v-flex>
        <v-layout wrap justify-start pb-10 pt-5>
          <v-flex xs12 sm6 lg3 xl3 text-left>
            <v-card rounded="lg" elevation="12">
              <v-layout wrap justify-end pa-4 class="bg1">
                <v-flex xs9 xl7 text-left>
                  <v-layout wrap justify-center>
                    <v-flex xs12 text-left>
                      <span class="analyticsValue">
                        {{ graphData.activeCustomers }}
                      </span>
                    </v-flex>
                    <v-flex xs12 text-left>
                      <router-link to="/Users" style="text-decoration: none">
                        <span class="analyticsKey"> Total Users</span>
                        <span class="itemArrow"> >> </span>
                      </router-link>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs3 xl4 text-center align-self-center>
                  <v-img
                    src="./../../assets/images/users.png"
                    height="50px"
                    contain
                  ></v-img>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex xs12 sm6 lg3 xl3 pl-0 pl-sm-4 pt-4 pt-sm-0 text-left>
            <v-card rounded="lg" elevation="12">
              <v-layout wrap justify-end pa-4 class="bg2">
                <v-flex xs9 xl7 text-left>
                  <v-layout wrap justify-center>
                    <v-flex xs12 text-left>
                      <span class="analyticsValue">
                        {{ graphData.orders }}
                      </span>
                    </v-flex>
                    <v-flex xs12 text-left>
                      <router-link
                        to="/Purchases"
                        style="text-decoration: none"
                      >
                        <span class="analyticsKey"> Total Orders</span>
                        <span class="itemArrow"> >> </span>
                      </router-link>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs3 xl4 text-center align-self-center>
                  <v-img
                    src="./../../assets/images/program.png"
                    height="50px"
                    contain
                  ></v-img>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex xs12 sm6 lg3 xl3 pl-0 pl-sm-4 pt-4 pt-sm-0 text-left>
            <v-card rounded="lg" elevation="12">
              <v-layout wrap justify-end pa-4 class="bg3">
                <v-flex xs9 xl7 text-left>
                  <v-layout wrap justify-center>
                    <v-flex xs12 text-left>
                      <span class="analyticsValue">
                        {{ graphData.activeSellers }}
                      </span>
                    </v-flex>
                    <v-flex xs12 text-left>
                      <router-link to="/Sellers" style="text-decoration: none">
                        <span class="analyticsKey"> Total Sellers</span>
                        <span class="itemArrow"> >> </span>
                      </router-link>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs3 xl4 text-center align-self-center>
                  <v-img
                    src="./../../assets/images/sellers.png"
                    height="50px"
                    contain
                  ></v-img>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex xs12 sm6 lg3 xl3 pl-0 pl-sm-4 pt-4 pt-sm-0 text-left>
            <v-card rounded="lg" elevation="12">
              <v-layout wrap justify-end pa-4 class="bg4">
                <v-flex xs9 xl7 text-left>
                  <v-layout wrap justify-center>
                    <v-flex xs12 text-left>
                      <span class="analyticsValue">
                        {{ graphData.pendingSellers }}
                      </span>
                    </v-flex>
                    <v-flex xs12 text-left>
                      <router-link
                        to="/sellerVerification"
                        style="text-decoration: none"
                      >
                        <span class="analyticsKey"> Pending Sellers</span>
                        <span class="itemArrow"> >> </span>
                      </router-link>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs3 xl4 text-center align-self-center>
                  <v-img
                    src="./../../assets/images/sellers.png"
                    height="50px"
                    contain
                  ></v-img>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
           <v-flex xs12 sm6 lg3 xl3 pt-5 text-left>
            <v-card rounded="lg" elevation="12">
              <v-layout wrap justify-end pa-4 class="bg5">
                <v-flex xs9 xl7 text-left>
                  <v-layout wrap justify-center>
                    <v-flex xs12 text-left>
                      <span class="analyticsValue">
                        {{ graphData.pendingProducts }}
                      </span>
                    </v-flex>
                    <v-flex xs12 text-left>
                      <router-link
                        to="/productVerification"
                        style="text-decoration: none"
                      >
                        <span class="analyticsKey"> Pending Products</span>
                        <span class="itemArrow"> >> </span>
                      </router-link>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs3 xl4 text-center align-self-center>
                  <v-img
                    src="./../../assets/images/product.png"
                    height="50px"
                    contain
                  ></v-img>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
        <!-- <v-flex xs3 md3 pt-2>
          <v-card class="mb-2">
            <vue-element-loading
              :active="recentLoading"
              :is-full-screen="false"
            />
            <v-card-text class="p-3 clearfix">
              <v-list-item link to="/sellerVerification">
                <v-list-item-icon>
                  <v-icon x-large color="warning" class="py-0"
                    >mdi-timer-sand</v-icon
                  >
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title> Pending Sellers</v-list-item-title>
                  <v-list-item-subtitle class="info--text"
                    ><b
                      >Count : {{ graphData.pendingSellers }}</b
                    ></v-list-item-subtitle
                  >
                  <v-list-item-subtitle class="info--text">
                    <br />
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card-text>
          </v-card>
        </v-flex> -->
      </v-layout>
    </v-flex>
  </v-layout>
</template>


<script>
import axios from "axios";
// import ApexCharts from 'apexcharts'
const gradients = [
  ["#6c757d"],
  ["#6c757d"],
  ["#6c757d", "#6c757d", "#6c757d"],
  ["#21c1d6", "21c1d6"],
  ["#21c1d6", "#21c1d6", "#21c1d6"],
  ["#21c1d6", "#21c1d6", "#21c1d6"],
];

const gradients2 = [
  ["#1e88e5"],
  ["#1e88e5"],
  ["#1e88e5", "#1e88e5", "#1e88e5"],
  ["#1e88e5", "#1e88e5"],
  ["#1e88e5", "#1e88e5", "#1e88e5"],
  ["#1e88e5", "#1e88e5", "#1e88e5"],
];

export default {
  name: "BasicDashboard",

  data: () => ({
    graphSuccess: false,
    appLoading: false,
    year: new Date().getFullYear(),
    series: [
      {
        name: "Customers",
        // data: [44, 55, 57, 56, 61, 58, 63, 60, 66],
        data: [],
      },
      {
        name: "Orders",
        // data: [76, 85, 101, 98, 87, 105, 91, 114, 94],
        data: [],
      },
      {
        name: "Invoices",
        // data: [35, 41, 36, 26, 45, 48, 52, 53, 41],
        data: [],
      },
    ],
    chartOptions: {
      chart: {
        type: "bar",
        height: 350,
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "55%",
          endingShape: "rounded",
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        categories: [],
        //  categories: [
        //   "Feb",
        //   "Mar",
        //   "Apr",
        //   "May",
        //   "Jun",
        //   "Jul",
        //   "Aug",
        //   "Sep",
        //   "Oct",
        // ],
      },
      yaxis: {
        title: {
          text: "count",
        },
      },
      fill: {
        opacity: 1,
      },
      tooltip: {
        y: {
          formatter: function (val) {
            // return "$ " + val + " thousands";
            return val;
          },
        },
      },
    },

    customerheaders: [
      {
        text: "Cutomer#",
        align: "start",
        value: "customerID",

        sortable: false,
      },
      {
        text: "Company",
        align: "start",

        value: "companyName",
        sortable: false,
      },

      {
        text: "I/L Date",
        value: "initialDate",
        align: "start",

        sortable: false,
      },
    ],
    orderheaders: [
      {
        text: "Ord#",
        align: "start",
        value: "orderID",

        sortable: false,
      },
      { text: "Date", value: "orderDate", sortable: false },

      {
        text: "Company",
        value: "billToCompany",

        sortable: false,
      },

      {
        text: "Total",
        value: "totalAmount",

        align: "end",
        sortable: false,
      },
      // { text: "Agent/User", value: "agentCode", width: "10%", sortable: false },
    ],
    invoiceheaders: [
      {
        text: "Inv.#",
        align: "start",
        value: "invoiceID",

        sortable: false,
      },

      { text: "Date", value: "invoiceDate", sortable: true },
      {
        text: "Company",
        value: "billToCompany",

        sortable: false,
      },

      {
        text: "Amt",
        value: "totalAmount",

        align: "end",
        sortable: false,
      },
    ],
    recentCustomers: [],
    recentOrders: [],
    recentInvoices: [],
    todaysCustomers: [],
    todaysOrders: [],
    todaysInvoices: [],
    fill: true,
    gradient: gradients[4],
    gradients,
    padding: 8,
    radius: 50,
    value: [0, 2, 5, 9, 5, 10, 3, 5, 1, 8, 2, 9, 0],
    width: 1,

    fill2: true,
    gradient2: gradients2[4],
    gradients2,
    radius2: 0,
    padding2: 0,
    value2: [1, 2, 5, 9, 5, 10, 3, 5, 1, 8, 2, 9, 4],
    width2: 3,
    graphData: [],
    tasks: [
      {
        done: false,
        text: "Check emails of Mr.Shah",
      },
      {
        done: false,
        text: "Give salary to employee",
      },
    ],
    task: null,
    selected: [2],
    items: [
      {
        action: "15 min",
        headline: "Brunch this weekend?",
        title: "Ali Connors",
        subtitle:
          "I'll be in your neighborhood doing errands this weekend. Do you want to hang out?",
      },
      {
        action: "2 hr",
        headline: "Summer BBQ",
        title: "me, Scrott, Jennifer",
        subtitle: "Wish I could come, but I'm out of town this weekend.",
      },
      {
        action: "6 hr",
        headline: "Oui oui",
        title: "Sandra Adams",
        subtitle: "Do you have Paris recommendations? Have you ever been?",
      },
      {
        action: "12 hr",
        headline: "Birthday gift",
        title: "Trevor Hansen",
        subtitle:
          "Have any ideas about what we should get Heidi for her birthday?",
      },
      {
        action: "18hr",
        headline: "Recipe to try",
        title: "Britta Holt",
        subtitle:
          "We should eat this: Grate, Squash, Corn, and tomatillo Tacos.",
      },
    ],
    openAmount: null,
    openCount: null,
    balAmount: null,
    dashData: null,
    ttlOrders: null,
    ttlInvoices: null,
    ttlCustomers: null,
    graphLoading: false,
    recentLoading: false,
  }),
  computed: {
    completedTasks() {
      return this.tasks.filter((task) => task.done).length;
    },
    progress() {
      return (this.completedTasks / this.tasks.length) * 100;
    },
    remainingTasks() {
      return this.tasks.length - this.completedTasks;
    },
  },
  watch: {
    year() {
      this.graphSuccess = false;
      this.series[0].data = [];
      this.series[1].data = [];
      this.series[2].data = [];
      this.chartOptions.xaxis.categories = [];
      this.dashboardgraphData();
    },
  },

  beforeMount() {
    this.dashboardData();
    // this.dashboardgraphData();
    this.years();
    //  console.log( this.$route.path);
  },
  methods: {
    years() {
      const year = new Date().getFullYear();

      return Array.from(
        { length: year - 2000 },
        (value, index) => 2001 + index
      );
    },

    getDashboard() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/dashboard/data",

        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          if (response.data.status) {
            this.dashData = response.data.data;

            this.ttlOrders = this.dashData.orders;
            this.ttlInvoices = this.dashData.invoices;
            this.ttlCustomers = this.dashData.customers;
            this.appLoading = false;
            this.openOrderCount();
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    openOrderCount() {
      axios({
        method: "POST",
        url: "/openOrders/count/amount",

        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          //this.appLoading = false;
          if (response.data.status) {
            this.openCount = response.data.count;
            this.openAmount = response.data.amount;
            this.INVbalanceAmt();
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    INVbalanceAmt() {
      axios({
        method: "POST",
        url: "/invoices/balance",

        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          //this.appLoading = false;
          if (response.data.status) {
            this.balAmount = response.data.balance;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    dashboardgraphData() {
      this.graphLoading = true;

      axios({
        method: "POST",
        url: "/dashboard/stats",

        headers: {
          token: localStorage.getItem("token"),
        },
        params: {
          year: this.year,
        },
      })
        .then((response) => {
          this.graphLoading = false;

          if (response.data.status) {
            this.graphData = response.data.graph;
            for (var i = 0; i < this.graphData.length; i++) {
              if (this.graphData.length > 0) {
                this.chartOptions.xaxis.categories.push(
                  this.graphData[i].month
                );
                this.series[0].data.push(this.graphData[i].customer);
                this.series[1].data.push(this.graphData[i].order);
                this.series[2].data.push(this.graphData[i].invoice);
              }
            }

            //  this.updateSeriesLine();
            this.graphSuccess = true;

            // console.log('hjm',this.chartOptions.xaxis.categories)
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    updateSeriesLine() {
      var data = {};
      data.series = this.series;
      data.chartOptions = this.chartOptions;
      console.log(data);
      this.$refs.realtimeChart.updateSeries(
        [
          {
            data: this.series[0].data,
          },
        ],
        false,
        true
      );
    },

    dashboardData() {
      this.graphLoading = true;
      this.recentLoading = true;
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/admin/dashboard",

        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.graphLoading = false;
          this.recentLoading = false;
          this.appLoading = false;
          if (response.data.status) {
            this.graphData = response.data.data;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    dateDifference(date) {
      // var date1 = new Date().toISOString().substr(0, 10)
      // const _MS_PER_DAY = 1000 * 60 * 60 * 24;

      // Discard the time and time-zone information.

      const utc1 = new Date().toISOString().substr(0, 10);

      if (date) {
        var newdateFormat = date.split("T");
        var splitDate = newdateFormat[0].split("-");
        if (splitDate.count == 0) {
          return null;
        }

        var year = splitDate[0];
        var month = splitDate[1];
        var day = splitDate[2];
      }

      const utc2 = year + "-" + month + "-" + day;

      return Math.floor(
        (this.parseDate(utc1) - this.parseDate(utc2)) / (1000 * 60 * 60 * 24)
      );
    },

    parseDate(str) {
      var mdy = str.split("-");
      return new Date(mdy[0], mdy[1] - 1, mdy[2]);
    },
    ChangeFormateDate(oldDate) {
      if (oldDate) {
        var newdateFormat = oldDate.split("T");
        var splitDate = newdateFormat[0].split("-");
        if (splitDate.count == 0) {
          return null;
        }

        var year = splitDate[0];
        var month = splitDate[1];
        var day = splitDate[2];

        return month + "/" + day + "/" + year;
      }
    },
    customerrowClicked(item) {
      this.$router.push("/Customer/" + item._id);
    },
    orderrowClicked(item) {
      // console.log(item)
      this.$router.push("/Order/" + item._id);
    },
    invoicerowClicked(item) {
      this.$router.push("/Invoice/" + item._id);
    },
    orderClicked(item) {
      if (item.orderId) this.$router.push("/Order/" + item.orderId._id);
    },
  },
};
</script>
<style>
.analyticsKey {
  font-size: 16px;
  color: #ffffff;
  letter-spacing: 1px;
}
.analyticsValue {
  font-size: 25px;
  color: #ffffff;
}
.itemArrow {
  font-size: 12px;
  color: #ffffff;
}
.bg1 {
  background-image: linear-gradient(to right, #00f2fe 0%, #4facfe 100%);
}
.bg2 {
  background-image: linear-gradient(to right, #f093fb 0%, #f5576c 100%);
}
.bg3 {
  background-image: linear-gradient(to right, #43e97b 0%, #38f9d7 100%);
}
.bg4 {
  background-image: linear-gradient(to right, #fa709a 0%, #fee140 100%);
}
.bg5 {
  background-image: linear-gradient(to right, #43e97b 0%, #fee140 100%);
}
.bg6 {
  background-image: linear-gradient(to right, #7b6bd6 0%, #93d6e5 100%);
}
</style>